import { noop } from 'lodash';
import { createContext, useContext } from 'react';
import type { AgentSelectOption } from '$form-fields';

export enum ReferralView {
  NEW = 'NEW',
  OVERVIEW = 'OVERVIEW',
}

export type ReferralContext = {
  loading: boolean;
  /**
   * Submit-as list merged with the referral's own agents and this session's
   * selections. Display-only — for permission checks use
   * {@link ReferralContext.submitAsAgentsBase}.
   */
  submitAsAgents: AgentSelectOption[];
  /** Agents the session user is actually granted to submit as. */
  submitAsAgentsBase: AgentSelectOption[];
  isEditView: boolean;
  view: ReferralView;
  updateContext: (context: Partial<ReferralContext>) => void;
  registerSelectedAgent: (agent: AgentSelectOption) => void;
};

export const REFERRAL_CONTEXT_DEFAULTS = {
  loading: false,
  submitAsAgents: [],
  submitAsAgentsBase: [],
  isEditView: false,
  view: ReferralView.NEW,
  updateContext: noop,
  registerSelectedAgent: noop,
};

export const ReferralContext = createContext<ReferralContext>(
  REFERRAL_CONTEXT_DEFAULTS,
);

export function useReferralContext() {
  return useContext(ReferralContext);
}
